import { Chip, Grid, Typography } from "@mui/material";

import HighlightOffIcon from "@mui/icons-material/HighlightOff";

interface IProps {
    items: string[];
    varient?: "filled" | "outlined";
    labelId?: string;
    labelAriaLabel?: string;
    deleteButtonId?: string;
    deleteButtonAriaLabel?: string;
    deletable?: boolean;
    emptyItemsText?: string;
    onDeleted?: (newItems: string[], deletedItem: string, deletedItemIndex: number) => void;
}

const getRandomString = (length: number): string => {
    var randomChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var result = '';
    for ( var i = 0; i < length; i++ ) {
        result += randomChars.charAt(Math.floor(Math.random() * randomChars.length));
    }
    return result;
}

const generateTag = (index: number, value: string): string => {
    return `${index}-${value}-${getRandomString(5)}`
}

const ChipList = (props: IProps) => {
    const { items, varient, emptyItemsText, onDeleted, deletable, deleteButtonId, deleteButtonAriaLabel, labelId, labelAriaLabel } = props;

    

    return (
        <>
            {!items?.length && emptyItemsText && <>{<Typography>{emptyItemsText}</Typography>}</>}
            {items?.length > 0 && (
                <>
                    <Grid spacing={1} container alignItems="center">
                        {items.map((item, index) => (
                            <Grid key={`${item}-${index}`} item>
                                <Chip
                                    id={labelId ? generateTag(index, labelId) : undefined}
                                    aria-label={labelAriaLabel}
                                    variant={varient}
                                    label={item}
                                    deleteIcon={
                                        deletable ? (
                                            <HighlightOffIcon
                                                id={deleteButtonId ? generateTag(index, deleteButtonId) : undefined}
                                                aria-label={deleteButtonAriaLabel}
                                            />
                                        ) : (
                                            <></>
                                        )
                                    }
                                    onDelete={() => {
                                        const newItems = items.filter((_, i) => i !== index);
                                        onDeleted?.(newItems, item, index);
                                    }}
                                />
                            </Grid>
                        ))}
                    </Grid>
                </>
            )}
        </>
    );
};

export default ChipList;
